(() => {
  const root = document.querySelector('[data-gva-hand-tied-entry]');
  if (!root) return;

  const familyTag = root.dataset.familyTag || 'GVA Shade';
  // Empty for families without textures (Tapes): every shade is then eligible.
  const preferredTexture = root.dataset.preferredTexture || '';

  const tagValue = (tags, prefix) => {
    const tag = (tags || []).find((item) => item.startsWith(prefix));
    return tag ? tag.slice(prefix.length).trim() : '';
  };

  const shadeSortKey = (shade) => {
    const match = shade.match(/^(\d+)/);
    return [match ? parseInt(match[1], 10) : 999, shade.toUpperCase()];
  };

  const fetchAllProducts = async () => {
    const products = [];
    for (let page = 1; page <= 10; page += 1) {
      const response = await fetch(`/products.json?limit=250&page=${page}`);
      if (!response.ok) throw new Error(`products.json failed: ${response.status}`);
      const batch = (await response.json()).products || [];
      products.push(...batch);
      if (batch.length < 250) break;
    }
    return products;
  };

  const pickShade = (products) => {
    const shades = products
      .filter((product) => (product.tags || []).includes(familyTag))
      .map((product) => ({
        handle: product.handle,
        shade: tagValue(product.tags, 'Shade:'),
        texture: tagValue(product.tags, 'Texture:'),
        available: (product.variants || []).some((variant) => variant.available)
      }))
      .filter((shade) => shade.shade);

    if (!shades.length) return null;

    // Prefer the preferred texture, then anything; in-stock first so the
    // shopper never lands on a sold-out product. A family without textures
    // falls straight through to the in-stock pool.
    const pools = preferredTexture
      ? [
        shades.filter((s) => s.texture === preferredTexture && s.available),
        shades.filter((s) => s.texture === preferredTexture),
        shades.filter((s) => s.available),
        shades
      ]
      : [shades.filter((s) => s.available), shades];

    const pool = pools.find((candidates) => candidates.length);
    return [...pool].sort((a, b) => {
      const [an, at] = shadeSortKey(a.shade);
      const [bn, bt] = shadeSortKey(b.shade);
      return an - bn || at.localeCompare(bt);
    })[0];
  };

  const go = async () => {
    try {
      const target = pickShade(await fetchAllProducts());
      if (target) {
        // replace() keeps the master card out of session history, so Back
        // returns to the catalog instead of bouncing through the redirect.
        window.location.replace(`/products/${target.handle}`);
        return;
      }
    } catch (error) {
      /* fall through to the normal page */
    }
    // Nothing to redirect to — reveal the master product page as-is.
    root.remove();
  };

  go();
})();
